<div
  class="tw-flex tw-flex-col tw-col-span-2 xl:tw-col-span-1 tw-h-full tw-max-h-[700px] sm:tw-max-h-[500px] tw-justify-end tw-text-dark-light-dynamic">
  <div
    [ngClass]="{ 'tw-hidden': !showChartOptions, 'tw-flex-col tw-relative': layoutService.isSmallScreen$ | async }"
    class="charts-actions chart-options-mobile tw-flex tw-flex-row tw-justify-between tw-mb-2 tw-flex-wrap tw-gap-y-2 tw-text-dark-light-dynamic">
    <!-- data selection -->
    <app-option-toggle
      *ngIf="allowFieldSelection"
      label="Show:"
      [options]="seriesOptions"
      [maxOptions]="3"
      [selectedValue]="selectedSeries"
      (selectionChange)="onSeriesChanged($event)"
      class="tw-order-1 md:tw-order-2 tw-mb-2 md:tw-mb-0">
    </app-option-toggle>
    <!-- breakdown by -->
    <app-option-toggle
      *ngIf="allowFieldSelection"
      label="Breakdown by:"
      [options]="breakdownByToggleOptions"
      [selectedValue]="selectedBreakdownBy"
      (selectionChange)="onBreakdownChanged($event)"
      class="tw-order-1 md:tw-order-2 tw-mb-2 md:tw-mb-0">
    </app-option-toggle>
  </div>

  <!-- chart -->
  <div [style.height]="getChartContainerHeight()" class="tw-rounded tw-relative" [class.mat-card-shadow]="boxShadow">
    <div id="highchartsContainer-{{ chartId }}" class="tw-rounded"></div>
  </div>
</div>
